export default __webpack_public_path__ + "static/media/school-bench.ce351e83.svg";